import { styled } from "styled-components";
const BigTextImpl = styled("strong")(
  ({ theme }) => ({
    fontSize: 38,
    fontWeight: theme.fontWeight.medium,
    lineHeight: `calc(1em + 8px)`
  }),
  ({ $displayMode, theme }) => $displayMode === "dark" ? {
    color: theme.color.white10
  } : {
    color: theme.color.gray9
  }
);
export {
  BigTextImpl
};
